/* The Band — User guide: sticky TOC highlights the section in view. */
(function () {
  function init(root) {
    if (!root || root._bdUg) return;
    root._bdUg = true;
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-toc]'));
    var setSec = function (i) {
      links.forEach(function (a) {
        var on = +a.getAttribute('data-toc') === i;
        a.classList.toggle('is-on', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    };
    window.Dozzee.gsap(function (gsap, ScrollTrigger) {
      if (!document.body.contains(root)) return;
      root._bdCtx = gsap.context(function () {
        root.querySelectorAll('[data-gsec]').forEach(function (el, i) {
          ScrollTrigger.create({ trigger: el, start: 'top 45%', end: 'bottom 45%', onToggle: function (s) { if (s.isActive) setSec(i); } });
        });
      }, root);
    });
  }

  function boot(scope) {
    if (!window.Dozzee || !window.Dozzee.gsap) return setTimeout(function () { boot(scope); }, 50);
    (scope || document).querySelectorAll('[data-section-type="band-guide"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-section-type="band-guide"]');
    if (r && r._bdCtx) r._bdCtx.revert();
  });
})();
